/* eslint-disable no-unused-vars */
import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import { paragraphe } from '../Styles/Style';
import { DataButton, ElementInterface } from '../Objects/interfaces/AppInterface';
import useTailwindBrand from '../Theme/useTailwindBrand';


interface Props {
    data: ElementInterface[] | DataButton[] | undefined;
    value: number
    setValue: (React.Dispatch<React.SetStateAction<number>>) | ((v: number) => void)
    label?: string;
    customClass?: string;
    inputCustomClass?: string;
    classCustom?: string;
    placeholder?: string;
    // onClick?: any;
}

const TeachrInput = styled(InputBase)(({ }) => ({
    "& .MuiInputBase-input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: 'transparent',
        border: "none",
        padding: "0",
        // fontFamily: "Nunito, 'sans-serif'",
    },
}));

export default function SelectAuto({ data, value, setValue, label, customClass = "", inputCustomClass, placeholder, classCustom }: Props) {
    const { classes } = useTailwindBrand();
    const handleChange = (event: SelectChangeEvent<number>) => {
        setValue(event.target.value as number);
    };
    const isValueInOptions = data?.some((el: any) => el.value === value);
    const selectValue = isValueInOptions ? value : 0;

    return (
        <div className={`flex flex-col shadow-[rgba(0,0,0,0.25)] ${customClass ?? 'rounded-md'}`}>
            {label && <label className="text-black">{label}</label>}
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-autowidth-label">{label}</InputLabel>
                <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={selectValue}
                    onChange={handleChange}
                    className={`${inputCustomClass ?? `${classes.fontFamily} lg:text-left text-center ${classes.primaryText} font-bold pl-3 ${paragraphe}`}`}
                    input={<TeachrInput />}
                >
                    <MenuItem className={`${classCustom ?? 'text-sm'}`} disabled value={0}>
                        <em>{placeholder ?? 'Séléctionnez une option...'}</em>
                    </MenuItem>
                    {data?.map((element: ElementInterface | DataButton, key: number) => (
                        <MenuItem value={element.value} key={key} className={`${classes.fontFamily} ${element.classCustom ?? paragraphe}`} onClick={() => element.handleChange && element.handleChange()}>
                            {/* {element.icons && <span className="mr-2">{element.icons}</span>} */}
                            {element.title}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
